var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Gamefield } from "./Gamefield";
import { StrikesBallsOuts } from "./StrikesBallsOuts";
import { CurrentInning } from "./CurrentInning";
import { Bases } from "./Bases";
import { ScoreRowCells } from "./ScoreRowCells";
import { TeamName } from "./TeamName";
import { WrapWithAnimate } from "../../WrapWithAnimate";
var Baseball = /** @class */ (function (_super) {
    __extends(Baseball, _super);
    function Baseball(props) {
        var _this = _super.call(this, props) || this;
        _this.containerRef = React.createRef();
        _this.scrollToGamefield = _this.scrollToGamefield.bind(_this);
        _this.scrollToScoreboardTable = _this.scrollToScoreboardTable.bind(_this);
        _this.disableAnimation = _this.disableAnimation.bind(_this);
        _this.state = {
            shouldRunAnimation: false,
            animationProps: {
                animation: "scroll",
                axis: "x",
                duration: 0,
                container: null,
                complete: _this.scrollToScoreboardTable,
                runOnMount: true
            }
        };
        return _this;
    }
    Baseball.prototype.componentDidMount = function () {
        this.scrollToGamefield();
    };
    Baseball.prototype.scrollToGamefield = function () {
        var _this = this;
        this.setState(function (prevState) { return ({
            shouldRunAnimation: true,
            animationProps: __assign({}, prevState.animationProps, { container: _this.containerRef.current })
        }); });
    };
    Baseball.prototype.scrollToScoreboardTable = function (elements) {
        var _this = this;
        this.setState(function (prevState) { return ({
            shouldRunAnimation: prevState.shouldRunAnimation,
            animationProps: __assign({}, prevState.animationProps, { animation: "reverse", duration: 600, axis: undefined, container: null, complete: _this.disableAnimation })
        }); });
    };
    Baseball.prototype.disableAnimation = function (elements) {
        this.setState(function (prevState) { return ({
            shouldRunAnimation: false,
            animationProps: __assign({}, prevState.animationProps)
        }); });
    };
    Baseball.prototype.render = function () {
        var p = this.props;
        var eventId = "event-" + p.scoreboardData.eventId;
        //TO DO refactor once BE starts sending information regarding the active bases;
        var style = p.deviceDetect.isDesktop ? { backgroundImage: "" + p.backgroundImg } : undefined;
        var gamefieldHeading = !p.deviceDetect.isDesktop
            ? React.createElement(StrikesBallsOuts, { balls: p.scoreboardData.balls, strikes: p.scoreboardData.strikes, outs: p.scoreboardData.outs, ballsTranslation: p.dict.balls, strikesTranslation: p.dict.strikes, outsTranslation: p.dict.outs })
            : React.createElement(CurrentInning, { partsPhrase: p.dict.partsPhrase[p.scoreboardData.currentInning], inningsPhrase: p.dict.inningsPhraseShort, currentInning: p.scoreboardData.currentInning.toString() });
        var additionalData = p.deviceDetect.isDesktop
            ? React.createElement(StrikesBallsOuts, { balls: p.scoreboardData.balls, strikes: p.scoreboardData.strikes, outs: p.scoreboardData.outs, ballsTranslation: p.dict.balls, strikesTranslation: p.dict.strikes, outsTranslation: p.dict.outs })
            : React.createElement(CurrentInning, { partsPhrase: p.dict.partsPhrase[p.scoreboardData.currentInning], inningsPhrase: p.dict.inningsPhraseLong, currentInning: p.scoreboardData.currentInning.toString() });
        return (React.createElement("div", { className: "rj-baseball-scoreboard-wrapper rj-baseball-scoreboard-background-image", style: style, ref: this.containerRef },
            React.createElement("div", { className: "rj-baseball-scoreboard", key: eventId + "-scoreboard" },
                React.createElement(WrapWithAnimate, __assign({ shouldWrap: this.props.deviceDetect.isMobile && this.state.shouldRunAnimation }, this.state.animationProps),
                    React.createElement(Gamefield, { heading: gamefieldHeading },
                        React.createElement(Bases, { baseKey: eventId, bases: [0, 1, 2, 3], activeBases: [] }))),
                React.createElement("div", { className: "rj-baseball-scoreboard-score-table-wrapper" },
                    React.createElement("table", { className: "rj-baseball-scoreboard-score-table", key: eventId + "-score-table" },
                        React.createElement("thead", { className: "rj-baseball-scoreboard-score-headings" },
                            React.createElement("tr", { className: "rj-baseball-scoreboard-score-headings-row" },
                                React.createElement("td", { className: "rj-baseball-scoreboard-additional-data" }, additionalData),
                                React.createElement(ScoreRowCells, { rowCellkey: eventId + "-heading", scores: p.scoreboardData.displayedInnings, displayedInnings: p.scoreboardData.displayedInnings }),
                                React.createElement("td", { className: "rj-baseball-scoreboard-score-cell rj-baseball-scoreboard-runs", key: "event-" + eventId + "-score-table-runs" }, p.dict.runs),
                                React.createElement("td", { className: "rj-baseball-scoreboard-score-cell rj-baseball-scoreboard-hits" }, p.dict.hits))),
                        React.createElement("tbody", { className: "rj-baseball-scoreboard-scores" },
                            React.createElement("tr", { className: "rj-baseball-scoreboard-score-row", key: "event-" + eventId + "-score-row-1" },
                                React.createElement("td", { className: "rj-basebal-scoreboard-participant-name-cell", key: eventId + "-participant-1-name" },
                                    React.createElement(TeamName, { teamName: p.scoreboardData.participant1Name, clsName: "rj-basebal-scoreboard-team-name", isServing: p.scoreboardData.currentTeamServing === 1 })),
                                React.createElement(ScoreRowCells, { rowCellkey: eventId + "-team-1", scores: p.scoreboardData.homeInnings, displayedInnings: p.scoreboardData.displayedInnings }),
                                React.createElement("td", { className: "rj-baseball-scoreboard-score-cell rj-baseball-scoreboard-runs", key: eventId + "-participant-1-runs" }, p.scoreboardData.homeTotalInnings),
                                React.createElement("td", { className: "rj-baseball-scoreboard-score-cell rj-baseball-scoreboard-hits", key: eventId + "-participant-1-hits" }, p.scoreboardData.homeHits)),
                            React.createElement("tr", { className: "rj-baseball-scoreboard-score-row", key: "event-" + eventId + "-score-row-2" },
                                React.createElement("td", { className: "rj-basebal-scoreboard-participant-name-cell", key: eventId + "-participant-2-name" },
                                    React.createElement(TeamName, { teamName: p.scoreboardData.participant2Name, clsName: "rj-basebal-scoreboard-team-name", isServing: p.scoreboardData.currentTeamServing === 2 })),
                                React.createElement(ScoreRowCells, { rowCellkey: eventId + "-team-2", scores: p.scoreboardData.awayInnings, displayedInnings: p.scoreboardData.displayedInnings }),
                                React.createElement("td", { className: "rj-baseball-scoreboard-score-cell rj-baseball-scoreboard-runs", key: eventId + "-participant-2-runs" }, p.scoreboardData.awayTotalInnings),
                                React.createElement("td", { className: "rj-baseball-scoreboard-score-cell rj-baseball-scoreboard-hits", key: eventId + "-participant-2-hits" }, p.scoreboardData.awayHits))))))));
    };
    return Baseball;
}(React.Component));
export { Baseball };
//# sourceMappingURL=Baseball.js.map